import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';
// import {AuthGuard} from './auth/auth.guard';

/**
 * Global Routing
 */
const app_routing: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'}
  //{path: 'user', loadChildren: () => import('./user-default/user-default.module').then(m => m.UserDefaultModule)},
  //{path: 'admin', loadChildren: () => import('./admin/admin-base.module').then(m => m.AdminBaseModule)}
];

@NgModule({
  imports: [
   RouterModule.forRoot(app_routing)
  ],
  exports:[
    RouterModule
  ]
})
export class RoutingModule { }
